export class LedExtras {
    //COMMON
    constructor(panelLed = false, perimeterLed = false, linearLed = false, spotLed = false, threeAxisLed = false) {
        this.panelLed = panelLed;
        this.perimeterLed = perimeterLed;
        this.linearLed = linearLed;
        this.spotLed = spotLed;
        this.threeAxisLed = threeAxisLed;
    }
}
export var ExtraType;
(function (ExtraType) {
    ExtraType["NONE"] = "NONE";
    ExtraType["GLASS"] = "GLASS";
    ExtraType["GLASS_ZIPSCREEN"] = "GLASS_ZIPSCREEN";
    ExtraType["PARAPET"] = "PARAPET";
    ExtraType["PARAPET_ZIPSCREEN"] = "PARAPET_ZIPSCREEN";
    ExtraType["ZIPSCREEN"] = "ZIPSCREEN";
})(ExtraType || (ExtraType = {}));
